import { RefObject } from 'react';

export function isContainerVisible(elem: RefObject<HTMLDivElement>) {
  const container = elem.current;
  const containerBottom = container ? container.getBoundingClientRect().bottom : 0;

  return containerBottom < document.documentElement.clientHeight;
}
